import { IconButton, type IconButtonProps } from '@mui/material';

import { CalendarSvg } from '@assets';

export const CalendarButton = ({
  component = 'span',
  ...properties
}: IconButtonProps) => (
  <IconButton component={component} {...properties}>
    <CalendarSvg />
  </IconButton>
);
